module.exports = __webpack_public_path__ + "img/granola.642c28ac.png";